import { useRef, useState } from "react";
import { clearWaitlistIntent, parseFragment } from "@/api/endpoint";
import WaitlistModal from "./WaitlistModal";

/** One-shot Cloud waitlist entry point for links coming from ato-web. */
export default function CloudWaitlistDeepLink() {
  const intent = useRef(parseFragment());
  const [open, setOpen] = useState(intent.current.waitlist === "cloud");

  return (
    <WaitlistModal
      open={open}
      onClose={() => {
        setOpen(false);
        clearWaitlistIntent();
      }}
      product="cloud"
      source={intent.current.waitlist_source ?? "ato_web"}
    />
  );
}
